var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckUg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCheckUg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Options-received",
    transform: "translate(-156.000000, -204.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.233333,235.867463 C219.233333,253.146092 205.146092,267.233333 187.867463,267.233333 C170.588556,267.233333 156.5,253.145815 156.5,235.867463 C156.5,218.588834 170.588834,204.5 187.867463,204.5 C205.145815,204.5 219.233333,218.588556 219.233333,235.867463 Z M216.233333,235.867463 C216.233333,220.245361 203.488911,207.5 187.867463,207.5 C172.245688,207.5 159.5,220.245688 159.5,235.867463 C159.5,251.488911 172.245361,264.233333 187.867463,264.233333 C203.489238,264.233333 216.233333,251.489238 216.233333,235.867463 Z M198.236483,224.162963 L202.8,228.647976 L183.30315,247.807407 L172.933333,237.615976 L177.495475,233.130963 L183.30315,238.835354 L198.236483,224.162963 Z",
    id: "icCheckUg"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckUg);
export default __webpack_public_path__ + "static/media/icCheckUg.97d1a9dfaa2a197c73170abd0760e01b.svg";
export { ForwardRef as ReactComponent };